export enum FileExtensionsEnum {
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx',
  LINK = 'link',
}
